// ═══════════════════════════════════════════════════════════════
// Rule message {field} interpolation (F-023)
//
// Rule error messages may embed field-value tokens — e.g.
//   "Claim date of {claim_date} is after notice date of {notice_date}."
// At display time the VS substitutes each {token} with the offending value
// so the operator sees the actual data, not abstract field names. Reuses the
// same `{field}` token convention as FormulaField expressions.
// ═══════════════════════════════════════════════════════════════
const TOKEN_RE = /\{([a-zA-Z_][\w-]*)\}/g;
/**
 * Substitute `{fieldName}` tokens in a rule message with values from
 * `valuesByName`. Unknown tokens are left verbatim (readable, never a crash);
 * a known field with an empty value renders as an empty string. A
 * null/undefined message passes through unchanged.
 */
export function interpolateMessage(message, valuesByName) {
    if (message === undefined || message === null)
        return message ?? undefined;
    if (!message.includes("{"))
        return message;
    return message.replace(TOKEN_RE, (whole, name) => {
        if (Object.prototype.hasOwnProperty.call(valuesByName, name)) {
            return valuesByName[name] ?? "";
        }
        return whole; // unknown token — leave as-is
    });
}
//# sourceMappingURL=interpolate-message.js.map